import apiSlice from './apiSlice';
import { cleanParams } from '@/utils/helper';
import { NotificationCountResponse, NotificationListResponse } from '@/types/notificationTypes';

export const notificationApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMyNotifications: builder.query<
      NotificationListResponse,
      { skip?: number; take?: number; search?: string; type?: string } | void
    >({
      query: (params) => ({
        url: '/notifications',
        method: 'GET',
        params: cleanParams(params ?? {}),
      }),
    }),
    deleteSelectedNotification: builder.mutation<
      { success: boolean; message: string },
      { notificationIds: string[] }
    >({
      query: (body) => ({
        url: '/notifications',
        method: 'DELETE',
        body,
      }),
    }),
    deleteAllNotification: builder.mutation<{ success: boolean; message: string }, void>({
      query: () => ({
        url: '/notifications/all',
        method: 'DELETE',
      }),
    }),
    readNotification: builder.mutation<
      { success: boolean; data: any; message?: string },
      {
        notificationIds: string[];
        isRead: boolean;
      }
    >({
      query: (body) => ({
        url: '/notifications/read-status',
        method: 'PATCH',
        body,
      }),
    }),
    readAllNotifications: builder.mutation<{ success: boolean; message: string }, void>({
      query: () => ({
        url: '/notifications/read-all',
        method: 'PATCH',
      }),
    }),
    getNotificationsCount: builder.query<NotificationCountResponse, void>({
      query: () => ({
        url: '/notifications/unread-count',
        method: 'GET',
      }),
    }),
  }),
});
export const {
  useGetMyNotificationsQuery,
  useDeleteAllNotificationMutation,
  useDeleteSelectedNotificationMutation,
  useGetNotificationsCountQuery,
  useReadAllNotificationsMutation,
  useReadNotificationMutation,
} = notificationApi;
